import { useEffect } from 'react';

export default function useUploadListener({setIsDraggingFile}){

  const onDragEnter = (e) => {
    if( e.dataTransfer.types.length === 1 ){
      let isFiles = e.dataTransfer.types[0] == 'Files';
      //console.log(e.dataTransfer);
      if( isFiles ){
        setIsDraggingFile(true);
      }
    }
  };

  const onMouseLeave = (e) => {
    console.log("onMouseLeave uploadListener!");
    e = e ? e : window.event;
    var from = e.relatedTarget || e.toElement;
    if (!from || from.nodeName == "HTML") {
      // stop your drag event here
      // for now we can just use an alert
      setIsDraggingFile(false);
    }
  };



  useEffect(() => {
    window.addEventListener("dragenter", onDragEnter);
    document.addEventListener("mouseout", onMouseLeave);
    return () => {
      window.removeEventListener("dragenter", onDragEnter);
      document.removeEventListener("mouseout", onMouseLeave);
    };
  })
}
